import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from "../components/Button";
import Papa from "papaparse";
import { Link } from 'react-router-dom';
import {
  getEvaluationParametersRequest,
  showMarketDynamicsLabelingRequest,
  saveMarketDynamicsLabelingRequest,
  runDynamicsTest,
  uploadCSV,
  downloadCSV,
  dynamicsTestStatusRequest,
  runDynamicsLabelTestStatus
} from "../services/trademasterService";
import { Buffer } from "buffer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/evaluation.css";
import csvData from "../assets/Data_example.csv";
import MarketDynamicsModeling from "../assets/MarketDynamicsModeling.jpg";
import pipelineImage from "../assets/pipeline_image.jpeg";

export default function Evaluation({ sessionID, trainDatasetName }) {
  const [evaluationSessionID, setEvaluationSessionID] = useState("");
  const [fileData, setFileData] = useState("");
  const [fileMetaData, setFileMetaData] = useState("");
  const [datasetName, setDatasetName] = useState("");
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const [minimumLengthOfEachChunk, setMinimumLengthOfEachChunk] =
    useState<number>();
  const [labellingMethod, setLabellingMethod] = useState<string>();
  const [mergingMetric, setMergingMetric] = useState<string>();
  const [mergingMetricThreshold, setMergingMetricThreshold] =
    useState<number>();
  const [numberOfMarketStyle, setNumberOfMarketStyle] = useState<number>();
  const [maxLengthExpectation, setMaxLengthExpectation] = useState<number>();
  const [filterStrength, setFilterStrength] = useState<number>();
  const [keyIndicatorColName, setKeyIndicatorColName] = useState<string>();
  const [timestampColName, setTimestampColName] = useState<string>();
  const [ticColName, setTicColName] = useState<string>();
  const [maxConstraintSpanAllowed, setMaxConstraintSpanAllowed] =
    useState<number>();
  const [testDynamicLabel, setTestDynamicLabel] = useState<number>(0);

  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [dynamicModelingInProgress, setDynamicModelingInProgress] =
    useState(false);
  const [testDynamicLabelDisabled, setTestDynamicLabelDisabled] =
    useState(true);

  const [parametersOptions, setParametersOptions] = useState({});
  const [datasetNameOptions, setDatasetNameOptions] = useState([]);
  const [testDynamicLabelOptions, setTestDynamicLabelOptions] = useState(
    Array<number>
  );
  const [figure1Base64String, setFigure1Base64String] = useState("");
  const [figure1Url, setFigure1Url] = useState("");
  const [figure2Base64String, setFigure2Base64String] = useState("");
  const [figure2Url, setFigure2Url] = useState("");
  const [figure3Base64String, setFigure3Base64String] = useState("");
  const [figure3Url, setFigure3Url] = useState("");
  const [optionSelected, setOptionSelected] = useState({
    dataset_name: "",
    number_of_market_style: 3,
    evaluation_start_date: "",
    evaluation_end_date: "",
    length_time_slice: "",
    granularity: "0.5",
    bear_threshold: "",
    bull_threshold: "",
    test_dynamic_label: "0"
  });
  const [requestOutput, setRequestOutput] = useState("");
  const [requestOutput2, setRequestOutput2] = useState("");

  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const createSelectItems = (
    options: Array<string | number>
  ): JSX.Element[] => {
    let items: JSX.Element[] = [];
    if (options === undefined) {
      return items;
    }
    for (let i = 0; i <= options.length; i++) {
      if (options[i] !== undefined) {
        items.push(
          <option key={i} value={options[i]}>
            {options[i]}
          </option>
        );
      }
    }
    return items;
  };

  const notifyToast = (text, type) => {
    if (type == "success") {
      toast.success(text);
    } else if (type == "error") {
      toast.error(text);
    } else if (type == "info") {
      toast.info(text);
    }
  };

  async function dynamicTestStatusloop(sessionID) {
    let MDMEnd = false;
    while (MDMEnd === false) {
      if (MDMEnd) {
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, 10000));
      // do something here
      // test-status request
      let promise = dynamicsTestStatusRequest(sessionID);
      notifyToast(
        "Request submitted! Please be patient...",
        "info"
      );
      promise
        // eslint-disable-next-line no-loop-func
        .then((res) => {
          console.log("MDMStatusRequest", res);
          console.log("MDMStatusRequest.sessionid", res.session_id);
          // setEvaluationSessionID(res.session_id);
          let newStr = res.info;
          setRequestOutput(newStr);
          if (res.MDM_end === true) {
            // setEvaluationSessionID(res.session_id);
            setRequestOutput(res.info);
            notifyToast(
              "Market Dynamics Modeling Response Received! Output Updated",
              "success"
            );
            setFigure1Base64String(res.market_dynamic_labeling_visulization);
            setFigure2Base64String(res.market_dynamic_labeling_analysis);
            MDMEnd = true;
            setDynamicModelingInProgress(false);
          }
          notifyToast(
            "Market Dynamics Modeling status response received! Output updated. Please be patient..., the modeling is still running...",
            "success"
          );
        })
        .catch((error) => {
          console.log("error", error);
          notifyToast(error, "error");
          setDynamicModelingInProgress(false);
        });
    }
  }

  const getDateStrFromDate = (date: Date | undefined) => {
    if (date === undefined) {
      return "";
    }

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    let dateStr = `${year}-${month + 1}-${day}`;
    return dateStr;
  };

  const handleOptionChange = (e, option_name) => {
    setOptionSelected({ ...optionSelected, [option_name]: e.target.value });
  };

  const showMarketDynamicsLabelingOnClick = () => {
    setDynamicModelingInProgress(true);

    const optionSelected = {
      dataset_name: datasetName,
      startDate: getDateStrFromDate(startDate),
      endDate: getDateStrFromDate(endDate),
      number_of_market_style: numberOfMarketStyle,
      min_length_limit: minimumLengthOfEachChunk,
      labeling_method: labellingMethod,
      merging_metric: mergingMetric,
      merging_threshold: mergingMetricThreshold,
      max_length_expectation: maxLengthExpectation,
      filter_strength: filterStrength,
      key_indicator: keyIndicatorColName,
      timestamp: timestampColName,
      tic: ticColName,
      merging_dynamic_constraint: maxConstraintSpanAllowed
    };
    console.log('option', optionSelected);
    let promise = showMarketDynamicsLabelingRequest(
      evaluationSessionID,
      optionSelected
    );

    promise
      .then(async (res) => {
        console.log('showMarketDynamicsLabelingRequest', res);
        console.log(res.session_id);
        // await setEvaluationSessionID(res.session_id);
        // console.log("evaluationSessionID", evaluationSessionID);
        console.log(res.session_id);
        dynamicTestStatusloop(res.session_id);
        await setEvaluationSessionID(res.session_id);
        console.log(evaluationSessionID);
      })
      .catch((error) => {
        console.log("error", error);
        notifyToast("Error!!!", "error");
      });
  };

  const saveDownloadMarketDynamicsLabelingOnClick = (evaluationSessionID) => {
    console.log(evaluationSessionID);

    let promise = saveMarketDynamicsLabelingRequest(evaluationSessionID);
    promise
      .then((res) => {
        notifyToast(
          "Save Current Modeling Response Received! Output Updated",
          "success"
        );
        // setRequestOutput(res.info);
        let promise2 = downloadCSV(res.session_id);
        promise2
          .then((res) => {
            console.log("download response:", res);
            notifyToast("Download CSV Success!", "success");

            // Create a Blob from the response data
            const csvBlob = new Blob([res.data], { type: "text/csv" });

            // Create a temporary URL for the Blob
            const csvUrl = window.URL.createObjectURL(csvBlob);

            // Create a link element
            const link = document.createElement("a");
            link.href = csvUrl;
            link.setAttribute("download", `${res.filename}.csv`);

            // Simulate a click on the link to trigger the download
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(csvUrl);
            console.log("session_id for get parameters", res.session_id);
            let promise = getEvaluationParametersRequest(res.session_id);
            promise
              .then((res) => {
                console.log(res.test_dynamic_number);
                setTestDynamicLabelOptions(res.test_dynamic_number);
                setTestDynamicLabelDisabled(false);
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((error) => {
            // Handle error
            console.error("Error downloading CSV:", error);
          });
      })
      .catch((error) => {
        console.log("error", error);
        notifyToast("Error!!!", "error");
      });
  };

  const runDynamicTestOnClick = () => {
    if (evaluationSessionID === "") {
      alert("SessionID is not set. Train the dataset First!");
      return;
    }
    setTestDynamicLabelDisabled(true);
    let promise = runDynamicsTest(evaluationSessionID, testDynamicLabel);
    console.log("runDynamicsTest:", evaluationSessionID, testDynamicLabel);
    promise
      .then((res) => {
        console.log(res);
        dynamicsLabelTestStatusloop(evaluationSessionID, testDynamicLabel);
        console.log("runDynamicsTest:", evaluationSessionID, testDynamicLabel);
      })
      .catch((error) => {
        console.log("error", error);
        notifyToast("Error!!!", "error");
      });
  };

  async function dynamicsLabelTestStatusloop(sessionID, testDynamicLabel) {
    let end = false;
    while (end === false) {
      if (end) {
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, 10000));
      // do something here
      // test-status request
      let promise = runDynamicsLabelTestStatus(sessionID, testDynamicLabel);
      notifyToast(
        "dynamics Test status request submitted! Please be patient...",
        "info"
      );
      promise
        // eslint-disable-next-line no-loop-func
        .then((res) => {
          // setEvaluationSessionID(res.session_id);
          let newStr = res.info;
          setRequestOutput2(newStr);
          if (res.dynamics_testing_end === true) {
            // setEvaluationSessionID(res.session_id);
            setRequestOutput2(res.info);
            console.log(res.info);
            notifyToast(
              "Dynamics Test Response Received! Output Updated",
              "success"
            );
            setFigure3Base64String(res.radar_plot);
            end = true;
            setTestDynamicLabelDisabled(false);
          }
          notifyToast(
            "Dynamics Test status response received! Output updated. Please be patient..., the modeling is still running...",
            "success"
          );
        })
        .catch((error) => {
          setTestDynamicLabelDisabled(false);
          console.log("error", error);
          notifyToast(error, "error");
        });
    }
  }

  useEffect(() => {
    if (figure1Base64String) {
      //convert base64 to utf8array, then to Blob
      const byteString = Buffer.from(figure1Base64String, "base64");
      const blob = new Blob([byteString.buffer]);
      const url = URL.createObjectURL(blob);

      // Set the URL as the imageUrl state variable
      setFigure1Url(url);
    }
  }, [figure1Base64String]);

  useEffect(() => {
    if (figure2Base64String) {
      //convert base64 to utf8array, then to Blob
      const byteString = Buffer.from(figure2Base64String, "base64");
      const blob = new Blob([byteString.buffer]);
      const url = URL.createObjectURL(blob);

      // Set the URL as the imageUrl state variable
      setFigure2Url(url);
    }
  }, [figure2Base64String]);

  useEffect(() => {
    if (figure3Base64String) {
      //convert base64 to utf8array, then to Blob
      const byteString = Buffer.from(figure3Base64String, "base64");
      const blob = new Blob([byteString.buffer]);
      const url = URL.createObjectURL(blob);

      // Set the URL as the imageUrl state variable
      setFigure3Url(url);
    }
  }, [figure3Base64String]);

  function handleFileInputChange(event) {
    const file = event.target.files[0];
    console.log(file);
    setFileMetaData(file);

    Papa.parse(event.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        console.log(results.data);
        setFileData(results.data);
      }
    });
  }

  useEffect(() => {
    if (
      parametersOptions === "" ||
      parametersOptions === undefined ||
      datasetName === "" ||
      datasetName === undefined
    ) {
      return;
    }

    if (datasetName.includes("custom")) {
      setStartDate(undefined);
      setEndDate(undefined);
    } else {
      let newStartDate = parametersOptions.start_date[datasetName];
      setStartDate(new Date(newStartDate));
      let newEndDate = parametersOptions.end_date[datasetName];
      setEndDate(new Date(newEndDate));
    }
    let newMinimumLength = parametersOptions.min_length_limit[datasetName];
    setMinimumLengthOfEachChunk(newMinimumLength);
    let newLabelingMethod = parametersOptions.labeling_method[datasetName];
    setLabellingMethod(newLabelingMethod);
    let newMergingMetric = parametersOptions.merging_metric[datasetName];
    setMergingMetric(newMergingMetric);
    let newMergingMetricThreshold =
      parametersOptions.merging_threshold[datasetName];
    setMergingMetricThreshold(newMergingMetricThreshold);
    let newMaxLengthExpectation =
      parametersOptions.max_length_expectation[datasetName];
    setMaxLengthExpectation(newMaxLengthExpectation);
    let newFilterStrength = parametersOptions.filter_strength[datasetName];
    setFilterStrength(newFilterStrength);
    let newKeyIndicator = parametersOptions.key_indicator[datasetName];
    setKeyIndicatorColName(newKeyIndicator);
    let newTimestamp = parametersOptions.timestamp[datasetName];
    setTimestampColName(newTimestamp);
    let newTic = parametersOptions.tic[datasetName];
    setTicColName(newTic);
    let newMergingDynamicConstraint =
      parametersOptions.merging_dynamic_constraint[datasetName];
    setMaxConstraintSpanAllowed(newMergingDynamicConstraint);
    setNumberOfMarketStyle(5);
  }, [datasetName]);

  useEffect(() => {
    let promise = getEvaluationParametersRequest(sessionID);
    promise
      .then((res) => {
        setParametersOptions(res);
        setDatasetNameOptions(res.dataset_name);

        console.log(res);
      })
      .then(() => {
        console.log("trainDatasetName:", trainDatasetName);
        if (trainDatasetName !== "") {
          setDatasetName(trainDatasetName);

          const selectElement = document.getElementById("datasetSelect");

          for (let i = 0; i < selectElement.options.length; i++) {
            const option = selectElement.options[i];
            if (option.value === trainDatasetName) {
              option.selected = true;
              break;
            }
          }
        } else {
          const selectElement = document.getElementById("datasetSelect");
          let total = selectElement.options.length;
          const option = selectElement.options[total - 1];
          option.selected = true;
          setDatasetName(selectElement.options[total - 1].value);
        }

        console.log("trainSessionID:", trainDatasetName);
        if (sessionID !== "") {
          setEvaluationSessionID(sessionID);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  async function handleUploadFile(fileData) {
    console.log("fileData", fileData);
    await setUploadInProgress(true);
    await console.log("uploadInProgress1", uploadInProgress);
    await sleep(2000);

    let promise = uploadCSV(evaluationSessionID, fileData, fileMetaData);
    promise
      .then((res) => {
        console.log(res);
        console.log(res.session_id);

        setEvaluationSessionID(res.session_id);

        let promise = getEvaluationParametersRequest(res.session_id);
        promise
          .then((res) => {
            setParametersOptions(res);
            setDatasetNameOptions(res.dataset_name);

            console.log(res);
          })
          .then(() => {
            if (trainDatasetName !== "") {
              setDatasetName(trainDatasetName);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
      });

    await setUploadInProgress(false);
    await console.log("uploadInProgress2", uploadInProgress);

    return;
  }

  const CollapsibleBox = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="collapsible-box">
        <button className="collapsible-button" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "Hide Instructions" : "Show Instructions"}
        </button>

        {isOpen && (
          <div className="collapsible-content">
            <p className="instructions-container">
              Use the Market Dynamics Modeling Toolbox with these steps:
              <ol>
                <li>
                  Choose our dataset or upload your own dataset by ‘Upload Custom Dataset’ for market dynamics labeling. Please prepare your custom dataset following this{" "}
                  <a
                    href={csvData}
                    download
                    style={{ textDecoration: "underline" }}
                  >
                    {" "}
                    sample csv file
                  </a>.
                </li>
                <li>
                  Set the parameters and press <strong>Run Market Dynamics Modeling</strong> button to
                  show the dynamics segmentation result of the current setting, you
                  may tune the parameters until you are satisfied with the result.
                  Please refer to this{" "}
                  <a
                    href="https://github.com/TradeMaster-NTU/TradeMaster/blob/1.0.0/docs/source/tool/TradeMaster_Sandbox_whitepaper.pdf"
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    white paper
                  </a>
                  {" "}
                  for parameters tuning.
                </li>
                <li>
                  Press <strong>Save & Download Current Modeling</strong> button when you are done tuning
                  parameters. The this will save and download current modeling result for you. You may also
                  do this locally by using the{" "}
                  <a
                    href="https://github.com/TradeMaster-NTU/TradeMaster"
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    TradeMaster
                  </a>{" "}
                  and follow this{" "}
                  <a
                    href="https://github.com/TradeMaster-NTU/TradeMaster/blob/1.0.0/docs/source/tool/EvaluationSandbox_MDM.md"
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    tutorial
                  </a>{" "}.
                </li>
                <li>
                  <strong>(Optional)</strong> If you have an agent trained from <strong><Link to="/service">the Training Page</Link></strong>, you may choose the tested dynamics and press <strong>Test</strong> to test the agent you
                  trained.
                </li>
              </ol>
            </p>
          </div>
        )}
      </div>
    );
  };


  const CollapsibleBox_intro = () => {
    const [isOpen, setIsOpen] = useState(false);


  };


  const CollapsibleBox_parameters = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="collapsible-box">
        <button className="collapsible-button" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "Hide Explanation of Parameters" : "Show Explanation of Parameters"}
        </button>

        {isOpen && (
          <div className="collapsible-content">
            <p className="instructions-container">
              <ol>
                <li>
                  <strong>Start Date & End Date</strong>: Data from the start date to the end date will be used for market dynamics labeling
                </li>
                <li>
                  <strong>Minimum Length of Each Chunk</strong>: No chunk will have a length shorter than this value. Any pattern of length shorter than
                  this value will be viewed as a inseparable micro-structure and will be merged with the nearest chunk.
                </li>
                <li>
                  <strong>Dynamics Number to be Labeled</strong>: The dataset will be labeled into this number of market dynamics.
                </li>
                <li>
                  <strong>Merging Metric Threshold</strong>: The threshold for merging chunks, larger value encourage more merging and longer dynamics. Good start value: (1) day-level data: 0.03; (2) second-level data: 0.0003.
                </li>
              </ol>
            </p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>

      <div className="row aa">
        <div className="eva1" style={{width:'1200px',margin:'0 auto'}}>
          <h1 className="evt1">Market Dynamics Modeling Toolbox </h1>
          <div>
            <div className="collapsible-content">
              <h1 style={{ fontWeight: 550, marginTop: '30px' }}>Overview</h1>
              <p style={{ fontSize: '20px' }}>
                The market dynamics modeling toolbox is a sandbox tool for users to label the market dynamics of a given dataset. The toolbox will automatically label the market dynamics of the given dataset and visualize the result.
              </p>
              <div className="col center">
                <img
                  src={MarketDynamicsModeling}
                  alt="MarketDynamicsModeling"
                  className="feature-image"
                  style={{ width: "80%", height: "80%", marginTop: '20px' }}
                ></img>
              </div>
              <div style={{ fontSize: '20px', marginTop: '20px' }}>
                The raw data is de-noised with a filter and then sliced into minimum chunks.
                The chunks are then merged and labeled iteratively until convergence to get the market dynamics.
              </div>
              <br></br>
              <br></br>
              <p className="instructions-container">
                <h1 style={{ fontWeight: 550, marginTop: '10px' }}>Example Usages</h1>
                <div style={{ fontSize: '20px', marginTop: '20px' }}>
                  While finding a 'silver bullet' for any market is impossible, the market dynamics modeling toolbox can help you to divide the market dynamics of a given dataset.
                  Example usages include:
                </div>
                <ol>
                  <li style={{ fontSize: '16px', marginTop: '10px' }}> <strong>Evaluation</strong> : The labeled data can be used to evaluate the performance of trading strategies under different market dynamics.
                  </li>
                  <li style={{ fontSize: '16px', marginTop: '10px' }}>
                    <strong>Ensemble Learning</strong>: While the toolbox provide market dynamics label for the data, it can be used to ensemble different trading strategies to improve the performance.
                  </li>
                </ol>
              </p>

            </div>

          </div>
          <div className="collapsible-content">
            <p className="instructions-container" style={{ fontSize: '20px', marginTop: '40px' }}>
              Use the Market Dynamics Modeling Toolbox with these steps:
              <ol>
                <li style={{ fontSize: '16px', marginTop: '20px' }}>
                  Choose our dataset or upload your own dataset by ‘Upload Custom Dataset’ for market dynamics labeling. Please prepare your custom dataset following this{" "}
                  <a
                    href={csvData}
                    download
                    style={{ textDecoration: "underline" }}
                  >
                    {" "}
                    sample csv file
                  </a>.
                </li>
                <li style={{ fontSize: '16px', marginTop: '10px' }}>
                  Set the parameters and press <strong>Run Market Dynamics Modeling</strong> button to
                  show the dynamics segmentation result of the current setting, you
                  may tune the parameters until you are satisfied with the result.
                  Please refer to this{" "}
                  <a
                    href="https://github.com/TradeMaster-NTU/TradeMaster/blob/1.0.0/docs/source/tool/TradeMaster_Sandbox_whitepaper.pdf"
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    white paper
                  </a>
                  {" "}
                  for parameters tuning.
                </li>
                <li style={{ fontSize: '16px', marginTop: '10px' }}>
                  Press <strong>Save & Download Current Modeling</strong> button when you are done tuning
                  parameters. The this will save and download current modeling result for you. You may also
                  do this locally by using the{" "}
                  <a
                    href="https://github.com/TradeMaster-NTU/TradeMaster"
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    TradeMaster
                  </a>{" "}
                  and follow this{" "}
                  <a
                    href="https://github.com/TradeMaster-NTU/TradeMaster/blob/1.0.0/docs/source/tool/EvaluationSandbox_MDM.md"
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    tutorial
                  </a>{" "}.
                </li>
                <li style={{ fontSize: '16px', marginTop: '10px', marginBottom: '80px' }}>
                  <strong>(Optional)</strong> If you have an agent trained from <strong><Link to="/service">the Training Page</Link></strong>, you may choose the tested dynamics and press <strong>Test</strong> to test the agent you
                  trained.
                </li>
              </ol>
            </p>
          </div>
        </div>

      </div>

      <div className="eva4">
        <h3 className="eva5">{'\u2460'} Choose the Dataset</h3>
        <div className="eva6">(1) If you want to test the agent with our dataset, choose the <strong> agent's training dataset</strong>. </div>
        <div className="eva6">(2) If you want to label your dataset, upload your own dataset by the <strong>Upload Custom Dataset</strong>
          button and select it. Make sure you have updated the custom Dataset info if it is different from the template. </div>
        <br></br>
        <br></br>
        <div className="session">
          {/*<span className="fw-lighter">Session ID: {evaluationSessionID}</span>*/}
          <span className="fw-lighter"></span>
        </div>
        <div className="row my-2">
          <div className="col">
            <div>

              <div className="">
                <div className="eva7"> Dataset Name</div>
                <select
                  className="form-select"
                  id="datasetSelect"
                  style={{ marginTop: '10px' }}
                  onChange={(e) => setDatasetName(e.target.value)}
                >
                  <option value="">Choose a dataset</option>
                  {createSelectItems(datasetNameOptions)}
                </select>

              </div>
            </div>
            {/*<p><strong>Choose the Agent Training Dataset to Test Your Agent</strong></p>*/}
            {/*<p><strong>Find Your Custom Dataset in Choice After Uploading</strong></p>*/}
          </div>
          <div className="col">
            <div className="file-input-container mb-3">
              {/*<label htmlFor="file-input" className="form-label ">*/}
              {/*  <strong>Or</strong> Upload your own Custom Dataset*/}
              {/*</label>*/}
              <div className="eva7"> choose file</div>
              <input
                className="form-control file-input"
                type="file"
                id="file-input"
                style={{ marginTop: '10px', height: '58px', lineHeight: '46px' }}
                onChange={(e) => handleFileInputChange(e)}
              />
            </div>

          </div>
          <Button
            onClick={() => {
              notifyToast("Uploading Custom Dataset", "info");
              console.log(fileData);
              handleUploadFile(fileData);
            }}
            disabled={uploadInProgress}
          >
            Upload Custom Dataset
          </Button>
        </div>
        <br></br>
        {/* <div className="row">
        <div className="offset-4 col-4">
          <button
              className="btn btn-primary"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseExample_custom"
              aria-expanded="false"
              aria-controls="collapseExample_custom"
              style={{ width: "100%", fontSize: "16px" }}
          >
            Custom Dataset Info <span className="caret"></span>
          </button>
        </div>
      </div> */}
        <div id="collapseExample_custom">
          <div className="row my-2">
            <div className="col">
              <div>
                <div className="eva7"> Tic Column Name (Set to'data' if not specified)</div>
                <input
                  type="text"
                  placeholder="Please Input"
                  style={{ marginTop: '10px' }}
                  id="key_indicator_column"
                  className="form-control"
                  value={ticColName}
                  onChange={(e) => setTicColName(e.target.value)}
                />
              </div>
            </div>
            <div className="col">
              <div>
                <div className="eva7"> Key Indicator Column Name</div>
                <input
                  type="text"
                  id="key_indicator_column"
                  style={{ marginTop: '10px' }}
                  placeholder="Please Input"
                  className="form-control"
                  value={keyIndicatorColName}
                  onChange={(e) => setKeyIndicatorColName(e.target.value)}
                />
              </div>
            </div>
            <div className="col">
              <div>
                <div className="eva7"> Timestamp Column Name</div>
                <input
                  type="text"
                  id="key_indicator_column"
                  style={{ marginTop: '10px' }}
                  className="form-control"
                  placeholder="Please Input"
                  value={timestampColName}
                  onChange={(e) => setTimestampColName(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>


        <div className="row my-2">
          {/*<div className="">*/}
          {/*  <strong>Download your processed data with market dynamics label*/}
          {/*  / will also save current modeling result for you to evaluate your agent later</strong>*/}
          {/*</div>*/}
        </div>


        <div className="row">
          {/*<pre className="output-container" style={{ position: 'relative' }}>*/}
          {figure1Url !== "" && <img src={figure1Url} alt="graph" />}
          {/*</pre>*/}
        </div>


      </div>


      <div className="aa" style={{ marginTop: '40px' }}>

        <div className="eva1">
          <h3 className="eva8">{'\u2461'} Set the Modeling Parameters</h3>
          <ol style={{ fontSize: '20px', lineHeight: '40px', marginTop: '20px' }}>
            <li>
              <strong>Start Date & End Date</strong>: Data from the start date to the end date will be used for market dynamics labeling
            </li>
            <li>
              <strong>Minimum Length of Each Chunk</strong>: No chunk will have a length shorter than this value. Any pattern of length shorter than
              this value will be viewed as a inseparable micro-structure and will be merged with the nearest chunk.
            </li>
            <li>
              <strong>Dynamics Number to be Labeled</strong>: The dataset will be labeled into this number of market dynamics.
            </li>
            <li>
              <strong>Merging Metric Threshold</strong>: The threshold for merging chunks, larger value encourage more merging and longer dynamics. Good start value: (1) day-level data: 0.03; (2) second-level data: 0.0003.
            </li>
          </ol>
          <div className="row my-2" >
            <div className="col" style={{ marginTop: '30px' }}>
              <div>Start Date</div>
              <DatePicker
                className="datepicker"
                id="startDatePicker"
                dateFormat="yyyy-MM-dd"
                placeholderText="YYYY-MM-DD"
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  let str = getDateStrFromDate(date);
                  let temp = optionSelected;
                  temp.evaluation_start_date = str;
                }}
                disabled={datasetName.includes("custom")}
              />
            </div>
            <div className="col" style={{ marginTop: '30px' }}>
              <div>End Date</div>
              <DatePicker
                className="datepicker"
                id="endDatePicker"
                dateFormat="yyyy-MM-dd"
                placeholderText="YYYY-MM-DD"
                selected={endDate}
                onChange={(date) => {
                  setEndDate(date);
                  let str = getDateStrFromDate(date);
                  let temp = optionSelected;
                  temp.evaluation_end_date = str;
                }}
                disabled={datasetName.includes("custom")}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div>Minimum Length of Each Chunk</div>
              <input
                type="number"
                placeholder="Please Input"
                id="numberInput"
                className="form-control"
                style={{ marginTop: '10px' }}
                min="1"
                onChange={(e) =>
                  setMinimumLengthOfEachChunk(Number(e.target.value))
                }
                value={minimumLengthOfEachChunk}
              />

            </div>
            <div className="col">
              <div>Dynamics Number to be Labeled</div>
              <input
                type="number"
                id="numberInput"
                placeholder="Please Input"
                style={{ marginTop: '10px' }}
                className="form-control"
                min="1"
                onChange={(e) => setNumberOfMarketStyle(Number(e.target.value))}
                value={numberOfMarketStyle}
              />
            </div>
          </div>


          {/*<div className="form-floating col">*/}
          {/*  <select*/}
          {/*    className="form-select"*/}
          {/*    id="floatingSelect"*/}
          {/*    onChange={(e) => setLabellingMethod(e.target.value)}*/}
          {/*    value={labellingMethod}*/}
          {/*  >*/}
          {/*    <option value="quantile">quantile</option>*/}
          {/*    <option value="slope">slope</option>*/}
          {/*  </select>*/}
          {/*  <label htmlFor="floatingSelect" className="select-label">*/}
          {/*    Labeling Method*/}
          {/*  </label>*/}
          {/*</div>*/}
          <div className="col">
            <div style={{ marginTop: '10px' }}>Merging Metric Threshold</div>
            <input
              type="number"
              id="numberInput"
              placeholder="Please Input"
              step="0.01"
              className="form-control"
              style={{ marginTop: '10px' }}
              min="1"
              value={mergingMetricThreshold}
              onChange={(e) => setMergingMetricThreshold(Number(e.target.value))}
            />
          </div>
        </div>
        {/* <div className="row">
          <div className="offset-4 col-4">
            <button
              className="btn btn-primary"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
              style={{ width: "100%", fontSize: "16px" }}
            >
              Advanced Parameters <span className="caret"></span>
            </button>
          </div>
        </div> */}
        <div  style={{ width: '1200px', margin: '0 auto' }}>
          <div className="row my-2">
            <div className="col">
              <div className="">
                <div className="seatIP">Maximum Constraint Span Allowed</div>
                <input
                  type="number"
                  id="numberInput"
                  placeholder="Please Input"
                  className="form-control"
                  style={{ marginTop: '10px' }}
                  value={maxConstraintSpanAllowed}
                  onChange={(e) =>
                    setMaxConstraintSpanAllowed(Number(e.target.value))
                  }
                />
              </div>
            </div>
            <div className="col">
              <div className="">
                <div className="seatIP">Max Length Expectation</div>
                <input
                  type="number"
                  style={{ marginTop: '10px' }}
                  id="numberInput"
                  placeholder="Please Input"
                  className="form-control"
                  min="1"
                  value={maxLengthExpectation}
                  onChange={(e) =>
                    setMaxLengthExpectation(Number(e.target.value))
                  }
                />
              </div>
            </div>
            <div className="col">
              <label htmlFor="customRange1" className="seatIP">
                Filter Strength: {filterStrength}
              </label>
              <input
                type="range"
                className="form-range"
                id="customRange1"
                style={{ marginTop: '20px' }}
                max={5}
                min={1}
                value={filterStrength}
                onChange={(e) => setFilterStrength(Number(e.target.value))}
              />
            </div>
            <div style={{ width: '100%', height: '80px' }}></div>
          </div>
        </div>
      </div>
      <div className="row my-2 eva4" style={{ paddingTop: '50px',width:'1200px',margin:'0 auto' }}>
        <div className="col button-col">
          <Button

            type="primary"
            onClick={() => {
              setFigure1Url("");
              setFigure2Url("");
              setFigure1Base64String("");
              setFigure3Base64String("");
              notifyToast(
                "Current Modeling Request submitted! Please Be Patient...",
                "info"
              );
              setRequestOutput("");
              showMarketDynamicsLabelingOnClick();
            }}
            disabled={dynamicModelingInProgress}
          >
            {'\u2462'} Run Market Dynamics Modeling
          </Button>
        </div>
        <div className="col button-col">
          <Button
            type="primary"
            onClick={() => {
              notifyToast(
                "Save Current Modeling Request submitted! Please Be Patient...",
                "info"
              );
              setRequestOutput("");
              saveDownloadMarketDynamicsLabelingOnClick(evaluationSessionID);
            }}
          >
            {'\u2463'} Save & Download Current Modeling
          </Button>
        </div>
      </div>
      <div>
        <div className="eva9">
          <div className="row my-2">
            <div className="col-6 form-floating">
              <h3 className="mt-5">Modeling Info</h3>
              <pre className="output-container">
                <code>{requestOutput}</code>
              </pre>
            </div>
            <div className="col-6">
              <h3 className="mt-5">Result Summary</h3>
              <pre className="output-container" style={{ height: '620px', position: 'relative' }}>
                {figure2Url !== "" && (
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      paddingTop: "100%"
                    }}
                  >
                    <img
                      src={figure2Url}
                      alt="analysis-graph"
                      className="img-fluid"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "620px",
                        objectFit: "cover"
                      }}
                    />
                  </div>
                )}
              </pre>
            </div>
          </div>
        </div>
      </div>

      <div className="aa">
        <div className="eva1">
        <h3 className="eva8">Result Visualization</h3>
      <h1 style={{marginTop:'10px'}}>Test Agent Trained from the <strong className="blue-strong" ><Link to="/service"> Training Page</Link></strong></h1>
      {/*<h3>You must first <strong>Train the agent</strong> to test it on specific market dynamics</h3>*/}
      <h3 className="eva8">{'\u2464'} Set the Test Market Dynamics</h3>
      <div className="row"></div>
      <div className="row">
        <div className=" col">
          <div> Test Dynamics Label</div>
          <select
            title="选项类型"
            className="form-select"
            id="floatingSelect"
            style={{marginTop:'10px'}}
            onChange={(e) => {
              setTestDynamicLabel(Number(e.target.value));
              console.log(testDynamicLabel);
            }}
          >
             <option selected>Please select</option>
            {createSelectItems(testDynamicLabelOptions)}
          </select>
        </div>

        <div style={{marginTop:'20px'}}>
          <Button
            type="primary"
            onClick={() => {
              setFigure3Url("");
              setFigure3Base64String("");
              notifyToast(
                "dynamics Test Request submitted! Please Be Patient...",
                "info"
              );
              setRequestOutput("");
              runDynamicTestOnClick();
            }}
            disabled={
              testDynamicLabelDisabled ||
              !(trainDatasetName !== "" && sessionID !== "")
            }
          >
            {'\u2465'}  Test
          </Button>
        </div>
      </div>

      <div className="row my-2">
        <div className="col-6 form-floating">
          <h3 className="mt-5">Test Result</h3>
          <pre className="output-container">
            <code>{requestOutput2}</code>
          </pre>
        </div>
        <div className="col-6">
          <h3 className="mt-5">Result Radar Plot</h3>
          <pre className="output-container" style={{ height: '620px', overflow: 'hidden', position: 'relative' }}>
            {figure3Url !== "" && <img src={figure3Url} alt="radar_plot" />}
          </pre>
        </div>
      </div>
        </div>
        <div style={{width:'100%',height:'50px'}}></div>
      </div>
      <ToastContainer />

    <div style={{width:'100%',height:'100px'}}></div>
    </div>
  );
}

